import { http } from '~/src/services/requests';
import { MavenConfig } from '@clio/maven-chat';

function mavenService() {
  return {
    getMavenJWT: async (orgFprint: string): Promise<MavenConfig> => {
      const response = await http.innerSendAuthenticated({
        relativePath: `/maven/org/${orgFprint}/jwt`,
        method: 'GET',
      });
      const signedUserData = await response.text();
      return { signedUserData };
    },
  };
}

export default mavenService();
